import { createContext, useContext } from "react";

// The signed-in user ({ first_name, last_name, email, role, ... }) and what the pages can do with it
export const AuthContext = createContext({ user: null, signOut: () => {}, expired: () => {} });
export const useAuth = () => useContext(AuthContext);
